var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":_vm.fluid || _vm.$vuetify.breakpoint.mdAndDown}},[_c('v-row',{attrs:{"dense":"","justify":_vm.justify}},[_c('v-col',{attrs:{"cols":"12","xl":_vm.xl}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }